/**
 * 開発・ローカル環境（localhost もしくは hostname に "dev" を含むドメイン）かどうかを判定する。
 * 本番・staging では false。開発限定フラグの共通判定に使う。
 */
function isDevOrLocalHost(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost";
  const hasDevInDomain = hostname.includes("dev");
  return isLocalhost || hasDevInDomain;
}

/**
 * 開発・ローカル環境限定の機能を有効にするかどうかを判定する。
 * 本番では課金回避等の理由で無効にし、開発時のみJSONのエクスポート/インポートを許可する。
 *
 * 有効条件: hostname が "localhost" であるか、ドメイン（hostname）に "dev" が含まれるときのみ true。
 */
export function isGenerationResultExportImportEnabled(): boolean {
  return isDevOrLocalHost();
}
